<template>
  <div class="echart_map">
    <!--<div id="mapStoreClass" stytle="z-index: 9999;"></div>-->
    <div id="main"  class="radarChart" ref='main_map'></div>
    <div class='alarm_box' v-if='alarm_list.length>0'>
      <!-- <div class='alarm_box' v-if='false' > -->
      <alarmBox  @deal='is_receive' :alarmContent='alarm_list' @showDeatil='alarmDetail'></alarmBox>
    </div>
    <div>
      <audio id='audiol'  preload='auto' style='display:none'>
        <source src="https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/mp3/baojing.mp3" type='audio/mpeg'>
      </audio>
    </div>
    <dialogItem :show-dialog="showDialog" @closeDialog='closeDialog' :dialogData='detail' @close_alarm='clear_alarm'></dialogItem>
  </div>
</template>

<script>
  import EChart from 'echarts'
  import {mapState, mapMutations} from 'vuex'
  import cityMap from './citymap.js'
  //   import {maps,geoCoordMap} from './data.js'
  import dataUrl from '../../../libs/js/interfaceAddress.js';
  import alarmBox from '../alarm/alarm_box.vue';
  import dialogItem from "../../../components/dialog/dialogs.vue";
  import goldenMaps from './baseMap/base_map_old'
  var myChart ='';
  export default {
    name: 'echart_map',
    props: {
      maps: {
        type: Object,
        default: () => {
          return {}
        }
      },
      mapName:{
        type: String,
        default: () => {
          return ''
        }
      },
      changeData:{
        type: Array,
        default: () => {
          return []
        }
      },
      changeDeviceId:{
        type: String,
        default: () => {
          return ''
        }
      },
      isStatus:{
        type: Boolean,
        default: () => {
          return false
        }
      }
    },
    components:{
      alarmBox,
      dialogItem,
      goldenMaps
    },
    data () {
      return {
        //弹框详情dialog
        showDialog:false,
        params:{},
        params:{},
        detail:{
          alarmDetailData:{},
          deviceData:{},
          mesData:{},
          presData:{}
        },
        //地图数据
        main_map: {
          option: null,
          chart: null,
          element: null,
        },
        map_data:{},
        mapdata:[],  //填充的数据
        provinces : {
          //23个省
          "台湾": "taiwan",
          "河北": "hebei",
          "山西": "shanxi",
          "辽宁": "liaoning",
          "吉林": "jilin",
          "黑龙江": "heilongjiang",
          "江苏": "jiangsu",
          "浙江": "zhejiang",
          "安徽": "anhui",
          "福建": "fujian",
          "江西": "jiangxi",
          "山东": "shandong",
          "河南": "henan",
          "湖北": "hubei",
          "湖南": "hunan",
          "广东": "guangdong",
          "海南": "hainan",
          "四川": "sichuan",
          "贵州": "guizhou",
          "云南": "yunnan",
          "陕西": "shanxi1",
          "甘肃": "gansu",
          "青海": "qinghai",
          //5个自治区
          "新疆": "xinjiang",
          "广西": "guangxi",
          "内蒙古": "neimenggu",
          "宁夏": "ningxia",
          "西藏": "xizang",
          //4个直辖市
          "北京": "beijing",
          "天津": "tianjin",
          "上海": "shanghai",
          "重庆": "chongqing",
          //2个特别行政区
          "香港": "xianggang",
          "澳门": "aomen"
        },
        // type:'province',  //省是 province  全国是 country
        // name:'shandong',
        type:'',  //省是 provinces  全国是 country
        name:'',
        areaList:[],  //区域色彩变化
        alarm_list:[], //报警列表数据

        clearMesInterval:null,
        onlineNum:0,   //今日实时在线个数

        header_search:[]  //头部搜索的判断条件
      }
    },
    mounted () {

      // this.$nextTick(()=>{
      //     this.initData();
      // })
      //    this.renderMap();
      //   this.page_init();
      let that = this;
      setTimeout(() => {
        //根据页面调整高度
        that.onWindowResize()
        window.addEventListener('resize',function(){
          that.onWindowResize();
        })
      }, 10);
      this.$bus.$off('map_init_bus').$on('map_init_bus',this.page_init);

      //初始化地图
      var newVal = this.Echartmap_config;
      if(JSON.stringify(newVal) !== "{}" && newVal.mapType && newVal.mapName){
        this.type = newVal.mapType;   //显示类型
        this.name = newVal.mapName;   //省市名称
        this.areaList =newVal.areaList;  //区域上色
        this.initData();

      }
    },
    computed:{
      ...mapState(['onMessageArrived','Echartmap_config']),
    },
    watch:{
      //地图显示数据
      // maps:{
      //     handler:function(newVal,oldVal){
      //         if(this.isStatus === false){
      //             return false
      //         }
      //
      //         if(JSON.stringify(newVal) !== "{}" && newVal.mapType && newVal.mapName){
      //             console.log(newVal,'newVal')
      //             this.type = newVal.mapType;   //显示类型
      //             this.name = newVal.mapName;   //省市名称
      //             this.areaList =newVal.areaList;  //区域上色
      //             this.initData();
      //
      //         }
      //     },
      //     deep:true
      // },
      //头部搜索实现地图定位
      changeData(newVal,oldVal){
        if(this.isStatus === false){
          return false
        }
        this.header_search = newVal;
        this.handle_search(newVal);
      },
      onMessageArrived:{

        handler(newVal,oldVal){
          if(this.isStatus === false){
            return false
          }
          var newInfo = typeof newVal == 'string' ? JSON.parse(newVal) : newVal;
          // this.handleAlarmType(newInfo);
          //判断推过来数据的类型 去刷相应的图表接口
          var n =this.onlineNum;
          if(newInfo.type=='offline'){
            // n--;
            // this.onlineNum =n;
            // this.set_onlineNum(this.onlineNum);
            //    this.page_init
          }else if(newInfo.type == 'online'){
            // n++;
            // this.onlineNum =n;
            // this.set_onlineNum(this.onlineNum);
            //  this.$bus.$emit('get-user-info-bus',this.getUserInfo); //页面初始化接口
            // this.page_init
          } else if(newInfo.type =='clearAlarm'||newInfo.type=='presAlarm'||newInfo.type=='mesAlarm'){
            this.$bus.$emit('get-alarmList-bus');  //报警列表接口
            this.$bus.$emit('get-chart-init'); //图表接口
          }
          else if(newInfo.type =='event'){
            // this.$bus.$emit('get-chart-init', this.init);
          }

          //处理推过来的数据
          try{
            for(let item in this.map_data){
              if(this.map_data[item] instanceof Array){
                this.map_data[item].forEach(i => {
                  if(newInfo.type == 'online' ){
                    if(i.deviceId==newInfo.deviceId){
                      // i.status=newInfo.status;
                      if(i.status!=1){
                        i.status='1';
                        //根据推过来的数据上下线加减
                        n++;
                        this.onlineNum =n;
                        this.set_onlineNum(this.onlineNum);
                      }

                    }
                  }
                  if(newInfo.type=='offline'){
                    if(i.deviceId==newInfo.deviceId){
                      if(i.status!=0){
                        i.status='0';
                        //根据推过来的数据上下线加减
                        n--;
                        this.onlineNum =n;
                        this.set_onlineNum(this.onlineNum);
                      }

                    }
                    this.alarm_list.forEach((_item,_index)=>{
                      if(_item.deviceId == newInfo.deviceId){
                        this.alarm_list.splice(_index,1);
                      }
                    });
                    if(this.alarm_list.length === 0){
                      window.baojingmp3.pause();
                      clearInterval(this.clearMesInterval);
                    }
                  }
                  if(newInfo.type =='event'){
                    if(i.deviceId==newInfo.deviceId){
                      i.nowState.valve = newInfo.valve;
                      // if(newInfo.valve == 0){
                      //     if(i.nowState && i.nowState.valve)i.nowState.valve ='关';
                      // } else{
                      //     if(i.nowState && i.nowState.valve)i.nowState.valve ='开';
                      // }
                      // if(i.nowState && i.nowState.mes)i.nowState.mes = newInfo.mes; console.log(i.nowState.valve,'开关阀')

                    }

                  }
                  if(newInfo.type =='clearAlarm'){
                    // this.$bus.$emit('get-alarmList-bus');
                    if(i.deviceId == newInfo.deviceId){
                      i.status='1';
                      if(i.nowState && i.nowState.mes)i.nowState.mes = newInfo.mes;
                    }
                    this.alarm_list.forEach((_item,_index)=>{
                      if(_item.deviceId == newInfo.deviceId && _item.alarmTypeId==newInfo.alarmTypeId){
                        this.alarm_list.splice(_index,1);
                      }
                    })
                    if(this.alarm_list.length === 0){
                      window.baojingmp3.pause();
                      clearInterval(this.clearMesInterval);
                    }
                  }
                  if(newInfo.type=='presAlarm'){
                    // this.$bus.$emit('get-alarmList-bus');
                    if(i.deviceId == newInfo.deviceId){
                      i.status='2'; // 数据
                      window.baojingmp3.pause();
                      clearInterval(this.clearMesInterval);

                      window.baojingmp3.play();
                      this.clearMesInterval=setInterval(()=>{
                        window.baojingmp3.play();
                      },1000);
                      // if(i.mes) i.mes = newInfo.mes;
                      // if(i.nowState && i.nowState.mes)i.nowState.mes = newInfo.mes;
                      if(i.nowState && i.nowState.inpres) i.nowState.inpres = newInfo.inpres
                      if(i.nowState && i.nowState.outpres) i.nowState.outpres = newInfo.outpres
                      if(i.nowState && i.nowState.temperature) i.nowState.inpres = newInfo.temperature

                      // mes：浓度值 inpres：进口压力值 outpres：出口压力值  temperature：温度


                    }
                    let newValInfo = this.alarm_list.filter((_item) => {
                      if(_item.deviceId == newInfo.deviceId&& _item.alarmTypeId==newInfo.alarmTypeId){
                        return _item;
                      }
                    })
                    if(newValInfo.length === 0){
                      this.alarm_list.push(newInfo);
                    }

                  }
                  if(newInfo.type=='mesAlarm'){
                    // this.$bus.$emit('get-alarmList-bus');
                    if(i.deviceId == newInfo.deviceId){
                      i.status='2'; // 数据
                      window.baojingmp3.pause();
                      clearInterval(this.clearMesInterval);
                      window.baojingmp3.play();
                      this.clearMesInterval=setInterval(()=>{
                        window.baojingmp3.play();
                      },1000)
                      // if(i.mes) i.mes = newInfo.mes;
                      if(i.nowState && i.nowState.mes)i.nowState.mes = newInfo.mes;
                      // mes：浓度值 inpres：进口压力值 outpres：出口压力值  temperature：温度

                    }
                    let newValInfo = this.alarm_list.filter((_item) => {
                      if(_item.deviceId == newInfo.deviceId && _item.alarmTypeId==newInfo.alarmTypeId){
                        return _item;
                      }
                    })
                    if(newValInfo.length === 0){
                      this.alarm_list.push(newInfo);
                    }

                  }
                });
              }
            }

          }catch(e){
            console.log(e)
          }
          //地图根据设备多少进行上色
          this.mapdata.forEach((item, index) => {
            if(this.areaList.length&&this.areaList.length!==''){
              this.areaList.forEach((i)=>{
                if(item.name === i.areaName){
                  item['value'] = i.areaStatus;
                }
              })
            }
          });
          this.renderMap(this.name,this.mapdata);
          //地图是否搜索后推数据过来，保留在搜索界面
          if(this.header_search.length>0){
            this.handle_search(this.header_search);
          }



        },
        deep:true
      },
    },
    methods: {
      ...mapMutations(['set_devToday','set_onlineNum']),
      //页面自适应
      onWindowResize(){
        let pageHeight = document.documentElement.clientHeight; //页面总高度
        if(document.querySelectorAll(".radarChart") && document.querySelectorAll(".radarChart")[0]){
          document.querySelectorAll(".radarChart")[0].style.height =  pageHeight - 265 + 'px';  //在这里可以根据你的边距做调整
        }
      },
      async handle_search(newVal){
        var num = [];
        for(let item in this.map_data){
          if(this.map_data[item] instanceof Array){
            this.map_data[item].forEach((i,index) => {
              if(newVal[1] == i.deviceId){
                num = [item,index]

              }
            })
          }
        }
        if((JSON.stringify(newVal[0]))==="[]"){
          this.main_map.option.geo.center = '[116.4071700000, 39.9046900000]';
          this.main_map.option.geo.zoom = 1;
          if(myChart!=null&&myChart!=''&&myChart!=undefined){
            myChart.dispose();
          }
          myChart = EChart.init(this.$refs.main_map);
          this.main_map.option.tooltip.triggerOn ='mousemove';
          this.main_map.option.tooltip.alwaysShowContent= false;
          myChart.setOption(this.main_map.option)
          myChart.dispatchAction({
            type:'hideTip',
            seriesIndex:num[0] ,//第几条series
            dataIndex: num[1],//第几个tooltip
          })
          this.renderMap(this.name,this.mapdata);
        } else{
          this.main_map.option.geo.center = newVal[0];
          this.main_map.option.geo.zoom =700;
          this.main_map.option.geo.roam= false;
          if(myChart!=null&&myChart!=''&&myChart!=undefined){
            myChart.dispose();
          }
          myChart = EChart.init(this.$refs.main_map);
          this.main_map.option.tooltip.triggerOn ='mousemove';
          this.main_map.option.tooltip.alwaysShowContent= true;
          myChart.setOption(this.main_map.option);
          myChart.dispatchAction({
            type:'highlight',
            seriesIndex:num[0] ,//第几条series
            dataIndex: num[1],//第几个tooltip
          })
          myChart.dispatchAction({
            type:'showTip',
            seriesIndex:num[0] ,//第几条series
            dataIndex: num[1],//第几个tooltip
          })
          // myChart.on('mouseover',function(){
          //
          // })
        }
      },
      //是否接警
      is_receive(item,index){
        // console.log("接受当前预警信息",item,index);
        // 请求接口 成功后 重新获取新数据

        this.getIsReceiveFunc(item);
        // this.page_init();
      },
      //接警处理
      getIsReceiveFunc(item){
        this.$http.post(dataUrl.interfaceAddress.answerAlarmUrl, {
          deviceId:item.deviceId || '',
          alarmTypeId:item.alarmTypeId || '',
        }).then(res => {
          // code=1时弹框小时，code=2时弹框继续显示，description 为提示语
          if(res.data&&res.data.code==1){
            this.alarm_list.forEach((_item,_index)=>{
              if(_item.deviceId == item.deviceId && _item.alarmTypeId==item.alarmTypeId){
                this.alarm_list.splice(_index,1);
              }
            })
            let message=res.data.description;
            this.$message({
              message: message,
              type: 'success'
            });
            if(this.alarm_list.length<=0){
              window.baojingmp3.pause();
              clearInterval(this.clearMesInterval);
            }
            this.$bus.$emit('get-alarmList-bus');

          } else {
            let message=res.data.description;
            this.$message.error(message);
          }
          // this.page_init();
        }).catch((err) => {
          console.log(err)
        })
      },
      //** /获取弹框的详情 **//

      //关闭弹窗
      async closeDialog(){
        this.showDialog = false;
      },
      //获取详情
      async alarmDetail(item,index){
        // this.showDialog = true;
        let params= {
          deviceId:item.deviceId || '',
          alarmTypeId:item.alarmTypeId || '',
          // deviceId:'867725030046175',
          // alarmTypeId:'1',
        }
        this.params = params;
        this.dialog_bottom_data();
      },
      //详情浓度曲线
      dialog_mes_data(){
        //  historyMes:context +'/getDev/historyMes',  //二级页面浓度曲线
        this.$http.post(dataUrl.interfaceAddress.historyMes, this.params).then(res => {
          //  console.log(res.data.data,'浓度数据')
          if(res.data.data&&res.data.code===1){
            this.detail.mesData = res.data.data;

          }
        }).catch((err) => {
          console.log(err)
          // reject(err)
        })
      },
      //详情压力曲线
      dialog_pres_data(){
        //   historyPres:context +'/getDev/historyPres',  //二级页面压力曲线
        this.$http.post(dataUrl.interfaceAddress.historyPres, this.params).then(res => {
          //  console.log(res.data.data,'压力数据')
          if(res.data.data&&res.data.code===1){
            this.detail.presData = res.data.data;

          }
        }).catch((err) => {
          console.log(err)
          // reject(err)
        })
      },
      //详情中间的内容
      dialog_device_data(){
        //  nowState:context +' /getDev/nowState',  //二级页设备信息实时数据
        this.$http.post(dataUrl.interfaceAddress.nowState, this.params).then(res => {
          //  console.log(res.data.data,'设备数据')
          if(res.data.data&&res.data.code===1){
            this.detail.deviceData = res.data.data;

          }
        }).catch((err) => {
          console.log(err)
          // reject(err)
        })
      },

      //详情最下面的条目内容
      dialog_bottom_data(){
        this.$http.post(dataUrl.interfaceAddress.infoDetail, this.params).then(res => {
          console.log(res.data.data,'获取的报警数据详情');
          if(res.data.data&&res.data.code===1){
            this.showDialog = true;
            this.detail.alarmDetailData = res.data.data;
            //获取图表数据
            this.dialog_mes_data();
            this.dialog_pres_data();
            this.dialog_device_data();
          } else {
            let message=res.data.description;
            this.$message.error(message);
          }
        }).catch((err) => {
          console.log(err)
          // reject(err)
        })
      },
      //详情中手动解除报警
      clear_alarm(){
        this.showDialog = false;
        this.$http.post(dataUrl.interfaceAddress.clearAlarmTask, this.params).then(res => {
          if(res.data&&res.data.code==1){
            let message=res.data.description;
            this.$message({
              message: message,
              type: 'success'
            });
            this.alarm_list.forEach((_item,_index)=>{
              if(_item.deviceId == this.params.deviceId && _item.alarmTypeId==this.params.alarmTypeId){
                this.alarm_list.splice(_index,1);

              }
            })
            if(this.alarm_list.length<=0){
              window.baojingmp3.pause();
              clearInterval(this.clearMesInterval);
            }
            this.$bus.$emit('get-alarmList-bus');
          } else {
            let message=res.data.description;
            this.$message.error(message);
          }

        }).catch((err) => {
          console.log(err)
        })

      },

      //** /获取弹框的详情 **//


      //页面初始化
      async page_init() {
        window.baojingmp3 = document.getElementById('audiol');
        this.$http.get(dataUrl.interfaceAddress.devAllUrl, {}).then(res => {
          // console.log("获取的标记点",res.data)
          if(res.data&&res.data.code ===1){
            var online = [];
            if(res && res.data && res.data.data){
              this.map_data = res.data.data;
              //找出初始化在线的数量
              for(let item in this.map_data){
                if((this.map_data[item] instanceof Array) && this.map_data[item].length){
                  this.map_data[item].forEach((_item,index) => {
                    if(_item.status == '1'){
                      online.push(_item);
                    };
                  })
                }
              }
              //将在线数存到vuex
              this.onlineNum = online.length;
              this.set_onlineNum(this.onlineNum);

              let devToday = res.data.data.devToday;
              let todayDev = [];
              if(JSON.stringify(devToday) !== "{}"){
                todayDev = [
                  {
                    // alarmDev:devToday.alarmDev,
                    onlineDev:devToday.onlineDev,
                    totalDev:devToday.totalDev
                  }
                ];
              } else {
                todayDev = [
                  {
                    // alarmDev:0,
                    onlineDev:0,
                    totalDev:0
                  }
                ];
              }
              this.set_devToday(todayDev);

              if(!res.data.data.alarmList){
                return
              }
              //处理初始化报警列表的数据
              if(res.data.data.alarmList.length>0){
                window.baojingmp3.pause();
                clearInterval(this.clearMesInterval);
                window.baojingmp3.play();
                this.clearMesInterval=setInterval(()=>{
                  window.baojingmp3.play();
                },1000)
                if(res.data.data.alarmList && Array.isArray(res.data.data.alarmList)){
                  this.alarm_list = res.data.data.alarmList;
                  // if(this.alarm_list.length === 2) {
                  //     this.alarm_list.push(res.data.data.alarmList[0]);
                  //     this.alarm_list.push(res.data.data.alarmList[1]);
                  // }
                }else{
                  window.baojingmp3.pause();
                  clearInterval(this.clearMesInterval);
                  throw new Error('alarmList is not Array')
                }
              } else{
                window.baojingmp3.pause();
                clearInterval(this.clearMesInterval);
              }

            }else{
              throw new Error('The interface return format is incorrect');
              let todayDev = [
                {
                  alarmDev:0,
                  onlineDev:0,
                  totalDev:0
                }
              ];
              this.set_devToday(todayDev);
            }
            // console.log(this.alarm_list,'页面初始化报警数据');
            // this.initData();
            this.renderMap(this.name,this.mapdata);
            // this.handlerClick();
            // resolve(res.data)
          }

        }).catch((err) => {
          console.log(err)
          // reject(err)
        })
      },
      //获取国家地图
      get_country_map(){
        this.mapdata = [];
        this.$http.get('../../../../static/map/china.json',{}).then(res => {
          var d = [];
          let data = res.data;
          //注册地图
          EChart.registerMap(this.name, data);
          for( var i=0;i<data.features.length;i++ ){
            d.push({
              name:data.features[i].properties.name
            })
          }
          this.mapdata = d;
          this.mapdata.forEach((item, index) => {
            if(this.areaList.length&&this.areaList.length!==''){
              this.areaList.forEach((i)=>{
                if(item.name === i.areaName){
                  item['value'] = i.areaStatus;
                }
              })
            }
          })

          //绘制地图
          this.renderMap(this.name,d);
        }).catch((err)=>{
          console.log(err)
        })
      },
      //获取省级地图
      get_provinces_map(params,j){
        var name =params||this.name;
        this.mapdata = [];
        this.$http.get('../../../../static/map/province/'+ name +'.json',{}).then(res => {
          let data = res.data;
          EChart.registerMap( name, data);
          var d = [];

          for( var i=0;i<data.features.length;i++ ){
            d.push({
              name:data.features[i].properties.name
            })
          }
          this.mapdata = d;
          this.mapdata.forEach((item, index) => {
            if(this.areaList.length&&this.areaList.length!==''){
              this.areaList.forEach((i)=>{
                if(item.name === i.areaName){
                  item['value'] = i.areaStatus;
                }
              })
            }

          })
          this.renderMap(name,d);
        }).catch((err)=>{
          console.log(err)
        })
      },
      //获取市级地图
      get_city_map(params){
        var name =params||this.name;
        this.mapdata = [];
        //  `https://xxxxxxxx/static/map/province/${name}.json`
        this.$http.get('../../../../static/map/city/'+ name +'.json',{}).then(res => {
          let data = res.data;
          EChart.registerMap( name, data);
          var d = [];

          for( var i=0;i<data.features.length;i++ ){
            d.push({
              name:data.features[i].properties.name
            })
          }
          this.mapdata = d;
          this.mapdata.forEach((item, index) => {
            if(this.areaList.length&&this.areaList.length!==''){
              this.areaList.forEach((i)=>{
                if(item.name === i.areaName){
                  item['value'] = i.areaStatus;
                }
              })
            }

          })
          this.renderMap(name,d);
        }).catch((err)=>{
          console.log(err)
        })
      },
      //初始化判断需要渲染的地图
      initData() {
        if(this.type=='country'){
          this.get_country_map();
        } else if(this.type=="province"){
          this.get_provinces_map();
        } else {
          this.get_city_map();
        }
        this.page_init();

      },
      //渲染地图
      renderMap(map,data){
        var convertData = (data,type) =>{
          var res = [];
          if (data instanceof Array) {
            for (var i = 0; i < data.length; i++) {
              res.push({
                value:data[i].position,
                nowState:data[i].nowState,
                type:type,
                realpos:data[i].realPos,
                device_status:data[i].status,  //设备状态
                // status=1绿色 status=0 灰色  status=2 红色
                itemStyle: {
                  normal: {
                    color: data[i].status == 0 ? '#56e660' : data[i].status == 1 ? '#56e660' : 'red',
                    shadowBlur: 5,
                    shadowColor: 'rgba(250,250,250,0)'
                  }
                },
              })

            }

          }
          return res;
        };
        let vue = this;
        this.main_map.option = {
          tooltip: {
            show: true,
            trigger:'item',
            position : function(p) {
              // 位置回调
              return [p[0] + 10, p[1] - 10];
            },
            // position:function(pos, params, dom, rect, size){
            //     var top = $(".BMap_mask").css("top");
            //     var left = $(".BMap_mask").css("left");
            //     top = top.substring(0, top.length - 2);
            //     left = left.substring(0, left.length - 2);
            //     return [pos0 + 20 - left, pos1 + 20 - top];
            // },
            // position: function(point, params, dom) {
            //     var width = $(dom).width();     //获取tooltip原来的width
            //     var m = $("#mapStoreClass");    //获取我们自定义模拟的tooltip dom
            //     $(dom).css("position","initial");    //将原来的tooltip设置为initial *重要，为了不让原来的tooltip dom乱跑
            //     $(m).html(dom);                      //将更改好的dom放入我们模拟的tooltip dom
            //     $(m).css("left",point[0]+20);        //设置模拟dom显示位置，此为鼠标位置
            //     $(m).css("top",point[1]+20);         //设置模拟dom显示位置，此为鼠标位置
            //     $(m).css("width",width+15);          //设置模拟dom宽度
            //     //不用return 在此我们只是用来获取我们想要的point和dom，并不更改原来的位置，因为改了也没用，不然我就不用这么麻烦了。。
            // },
            showContent:true,
            alwaysShowContent:true,
            // backgroundColor:'rgba(50,50,50,0.7)',
            triggerOn:'mousemove',
            enterable:false,
            backgroundColor: 'transparent',
            padding: [10, 10],
            textStyle:{
              align:'left'
            },
            formatter: function(params) {

              if(params.data){
                let type = params.data.type,
                  status = params.data.device_status,
                  device_status = status==0?'离线':status==1?'在线':'报警中',
                  address = params.data.realpos;
                //  if( params.data){
                //      let data = params.data;
                //  }
                let nowState = {
                  mes: "暂无",
                  valve: "开",
                  inpres: "暂无",
                  outpres:"暂无",
                  temperature: "暂无"
                }
                data =params.data.nowState;
                if(data){
                  //  var  valves = data.valve==0?'关':'开';
                  var valves = data.valve;
                }

                //1 为民品 2：工业品  3工商品
                //    if(type == '1'){
                //        return '设备状态：'+ device_status+'<br/>'+'浓度值：'+data.mes+'<br/>'+'阀门状态：'+valves+'<br/>'
                //    } else if(type == '2'){
                //        return '设备状态：'+ device_status+'<br/>'+'浓度值：'+data.mes+'<br/>'+'进口压力：'+data.inpres+'<br/>'+'出口压力：'+data.outpres+'<br/>'+'温度：'+data.temperature
                //    } else if(type =='3'){
                //         return '设备状态：'+ device_status+'<br/>'+'浓度值：'+data.mes+'<br/>'
                //    }
                // var  offLineColor = 'rgba(255,255,255,.4)';
                // var  onLineColor = 'rgba(34,172,56,.6)';
                // var  alarmColor = 'rgba(255,0,0,.4)';
                if(type == '1'){
                  if(status == 0){
                    return '<div style="background-color:rgba(255,255,255,.4); padding:10px;border-radius:5px;">'
                      // +'设备状态：'+ device_status+'<br/>'
                      +'<span style="font-size:16px;">'+address+'</span>'+'<br/>'+'浓度：'+data.mes+'<br/>'+'阀门：'+valves+'<br/>'+'</div>'
                  } else if(status == 1){
                    return '<div style="background-color:rgba(34,172,56,.6);padding:10px;border-radius:5px;">'
                      // +'设备状态：'+ device_status+'<br/>'
                      +'<span style="font-size:16px;">'+address+'</span>'+'<br/>'+'浓度：'+data.mes+'<br/>'+'阀门：'+valves+'<br/>'+'</div>'
                  } else {
                    return '<div style="background-color:rgba(255,0,0,.4);padding:10px;border-radius:5px;">'
                      // +'设备状态：'+ device_status+'<br/>'
                      +'<span style="font-size:16px;">'+address+'</span>'+'<br/>'+'浓度：'+data.mes+'<br/>'+'阀门：'+valves+'<br/>'+'</div>'
                  }

                } else if(type == '2'){
                  if(status == 0){
                    return '<div style="background-color:rgba(255,255,255,.4);padding:10px;border-radius:5px;">'
                      // +'设备状态：'+ device_status+'<br/>'
                      +'<span style="font-size:16px;">'+address+'</span>'+'<br/>'+'浓度：'+data.mes+'<br/>'+'进口压力：'+data.inpres+'<br/>'
                      +'出口压力：'+data.outpres+'<br/>'+'温度：'+data.temperature +'<br/>' +'</div>'
                  } else if(status == 1){
                    return '<div style="background-color:rgba(34,172,56,.6);padding:10px;border-radius:5px;">'
                      // +'设备状态：'+ device_status+'<br/>'
                      +'<span style="font-size:16px;">'+address+'</span>'+'<br/>'+'浓度：'+data.mes+'<br/>'+'进口压力：'+data.inpres+'<br/>'
                      +'出口压力：'+data.outpres+'<br/>'+'温度：'+data.temperature +'<br/>' +'</div>'
                  } else {
                    return '<div style="background-color:rgba(255,0,0,.4);padding:10px;border-radius:5px;">'
                      // +'设备状态：'+ device_status+'<br/>'
                      +'<span style="font-size:16px;">'+address+'</span>'+'<br/>'+'浓度：'+data.mes+'<br/>'+'进口压力：'+data.inpres+'<br/>'
                      +'出口压力：'+data.outpres+'<br/>'+'温度：'+data.temperature +'<br/>' +'</div>'
                  }

                } else if(type =='3'){
                  if(status == 0){
                    return '<div style="background-color:rgba(255,255,255,.4);padding:10px;border-radius:5px;">'
                      // +'设备状态：'+ device_status+'<br/>'
                      +'<span style="font-size:16px;">'+address+'</span>'+'<br/>'+'浓度：'+data.mes+'<br/>'+'阀门：'+valves+'<br/>'+'</div>'
                  } else if(status == 1){
                    return '<div style="background-color:rgba(34,172,56,.6);padding:10px;border-radius:5px;">'
                      // +'设备状态：'+ device_status+'<br/>'
                      +'<span style="font-size:16px;">'+address+'</span>'+'<br/>'+'浓度：'+data.mes+'<br/>'+'阀门：'+valves+'<br/>'+'</div>'
                  } else {
                    return '<div style="background-color:rgba(255,0,0,.4);padding:10px;border-radius:5px;">'
                      // +'设备状态：'+ device_status+'<br/>'
                      +'<span style="font-size:16px;">'+address+'</span>'+'<br/>'+'浓度：'+data.mes+'<br/>'+'阀门：'+valves+'<br/>'+'</div>'
                  }


                }
              }

            },
          },
          visualMap: {
            show:false,
            type: 'continuous',
            orient: 'horizontal',
            itemWidth: 10,
            itemHeight: 80,
            text: ['高', '低'],
            showLabel: true,
            seriesIndex: [0],
            min: 1,
            max: 3,
            inRange: {
              color: ['#396cb5','#213e7c','#252f6a']
            },
            textStyle: {
              color: '#7B93A7'  //值域控件的文本颜色
            },
            bottom: 30,
            left: 'left',
          },
          // animationDuration:1000,
          // animationEasing:'cubicOut',
          // animationDurationUpdate:1000,
          geo: {
            map: vue.name,
            show: true,
            roam: true,
            zoom: '',
            center: '',
            // label: {
            //     emphasis: {
            //         show: false
            //     }
            // },
            // itemStyle: {
            //     normal: {
            //         areaColor: '#323C48',
            //         borderColor: '#252C32',
            //         shadowColor: '#e0dd85',
            //         shadowBlur: 20
            //     }
            // }
            label: {
              normal:{
                show:true,
                textStyle:{
                  color:'#999', //设置字体静止时的颜色
                  fontSize:12
                }
              },
              emphasis: {
                show: false,
                textStyle:{
                  color:'#fff',  //设置鼠标移上去字的颜色
                  fontSize:12
                }
              }
            },
            itemStyle: {
              normal: {
                areaColor: '#396cb5', //设置各省的颜色
                borderColor: '#020443',  //设置划分区边的颜色
                shadowColor: '#3B5077',
                // shadowBlur: 100,
                // color:'red'
              },
              emphasis: {
                label:{show:true},
                areaColor: ''  //设置鼠标移上去各省的颜色
              },

            },


          },
          series: [
            //effectScatter
            {
              name: 'mapSer',
              type: 'map',
              roam: true,
              geoIndex: 0,
              label: {
                show: false,
              },
              data: data
            },
            {
              type: 'effectScatter',
              coordinateSystem: 'geo',
              symbolSize:25,
              showEffectOn: 'emphasis',
              effectType:"ripple",
              // rippleEffect: {
              //     brushType: 'stroke'
              // },
              hoverAnimation: false,
              data: convertData(vue.map_data[1],1),
              // symbolSize: function (val) {
              //     return val[2] / 20;
              // },
              label: {
                normal: {
                  formatter: '{b}',
                  // position: 'left',
                  position: [10, 10],
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
            },
            {
              type: 'effectScatter',
              coordinateSystem: 'geo',
              symbolSize:25,
              showEffectOn: 'emphasis', //'render' 绘制完成后显示特效。'emphasis' 高亮（hover）的时候显示特效
              effectType:"ripple",
              // rippleEffect: {
              //     brushType: 'stroke'
              // },
              hoverAnimation: false,
              data: convertData(vue.map_data[2],2),
              // symbolSize: function (val) {
              //     return val[2] / 20;
              // },
              label: {
                normal: {
                  formatter: '{b}',
                  // position: 'right',
                  position: [10, 10],
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
            },
            {
              type: 'effectScatter',

              coordinateSystem: 'geo',
              symbolSize:25,
              showEffectOn: 'emphasis',
              effectType:"ripple",
              // rippleEffect: {
              //     brushType: 'stroke'
              // },
              hoverAnimation: false,
              data: convertData(vue.map_data[3],3),
              label: {
                normal: {
                  formatter: '{b}',
                  // position: 'right',
                  position: [10, 10],
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
            },
            // {
            //     type: 'scatter',
            //     coordinateSystem: 'geo',
            //     data: convertData(vue.map_data[4],4),
            //     // symbolSize: function (val) {
            //     //     return val[2] / 20;
            //     // },
            //     label: {
            //         normal: {
            //             formatter: '{b}',
            //             position: 'right',
            //             show: false
            //         },
            //         emphasis: {
            //             show: true
            //         }
            //     },
            //     itemStyle: {
            //         normal: {
            //             color: '#ddb926'
            //         }
            //     }
            // },
            // {
            //     // name: '城市',
            //     type: 'scatter',
            //     coordinateSystem: 'geo',
            //     data: convertData(vue.map_data[5],5),
            //     // symbolSize: function (val) {
            //     //     return val[2] / 20;
            //     // },
            //     label: {
            //         normal: {
            //             formatter: '{b}',
            //             position: 'right',
            //             show: false
            //         },
            //         emphasis: {
            //             show: true
            //         }
            //     },
            //     itemStyle: {
            //         normal: {
            //             color: '#ddb926'
            //         }
            //     }
            // },
          ]
        };
        if(myChart!=null&&myChart!=''&&myChart!=undefined){
          myChart.dispose();
        }
        myChart = EChart.init(this.$refs.main_map);
        myChart.setOption(this.main_map.option);
        // myChart.resize();
        window.addEventListener('resize', this.onWindowResize);

      },

      //地图点击下砖到省市
      // handlerClick(){
      //     myChart.on('click', (params) => {
      //         let special = ["北京","天津","上海","重庆","香港","澳门"];
      //         let mapdata = [];
      //         if( params.name in this.provinces){
      //             this.get_provinces_map(this.provinces[params.name]);
      //             this.name = this.provinces[params.name];
      //         }else if(params.name in cityMap){
      //             //如果是【直辖市/特别行政区】只有二级下钻
      //             if(special.indexOf( params.name ) >=0  ){
      //                 this.get_country_map();
      //             }else{
      //                 this.get_city_map(params.name);
      //                 this.name = params.name;
      //             }
      //         }else{
      //             this.get_country_map();
      //         }
      //     });
      // },

    },
    beforeDestroy(){
      // myChart.clear();
      window.removeEventListener('resize',this.onWindowResize);
      this.$bus.$off('map_init_bus',this.page_init);

    },
    destory(){
      window.onresize = null;
      clearInterval(this.clearMesInterval);   //清除音乐的定时器
    },

  }
</script>
<style lang="less" scoped>
  .echart_map {
    text-align: center;
    position: relative;
    background: url(https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/img/icon.png) no-repeat;
    background-position: 90% 97%;
    .radarChart{
      // height: 700px; //大
      // height:640px;
    }
    .alarm_box{
      width:614px;
      height: 314px;
      // opacity: 0.5;
      position: fixed;
      top:50%;
      left:50%;
      margin:-157px 0 0 -307px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/main_content/map/echartMap.vue